import api from '@/utils/api'

/**
 * 外部订单服务
 */

// 获取订单列表
export const getExternalOrders = async (params = {}) => {
  try {
    const response = await api.get('/api/orders/external-orders/', { params })
    return {
      success: true,
      data: response.data
    }
  } catch (error) {
    console.error('获取订单列表失败:', error)
    return {
      success: false,
      message: error.response?.data?.message || error.message || '获取订单列表失败'
    }
  }
}

// 获取订单详情
export const getExternalOrder = async (id) => {
  try {
    const response = await api.get(`/api/orders/external-orders/${id}/`)
    return {
      success: true,
      data: response.data
    }
  } catch (error) {
    console.error('获取订单详情失败:', error)
    return {
      success: false,
      message: error.response?.data?.message || error.message || '获取订单详情失败'
    }
  }
}

// 创建订单
export const createExternalOrder = async (data) => {
  try {
    // 如果是 FormData，直接发送；否则清理数据
    let cleanData = data
    if (!(data instanceof FormData)) {
      // 创建一个新对象，排除图片字段和空对象
      cleanData = {}
      const imageFields = ['order_screenshot', 'paypal_refund_screenshot', 'review_screenshot']
      
      Object.keys(data).forEach(key => {
        // 排除图片字段
        if (imageFields.includes(key)) {
          return
        }
        // 排除 undefined 和空对象
        if (data[key] !== undefined && typeof data[key] !== 'object' || data[key] === null || Array.isArray(data[key])) {
          cleanData[key] = data[key]
        } else if (typeof data[key] === 'object' && data[key] !== null && !Array.isArray(data[key]) && Object.keys(data[key]).length > 0) {
        cleanData[key] = data[key]
      }
    })
  }
  
  // 如果是 FormData，需要设置正确的 headers
    const config = {}
    if (data instanceof FormData) {
      config.headers = {
        'Content-Type': 'multipart/form-data'
      }
    }
    
    const response = await api.post('/api/orders/external-orders/', cleanData, config)
    return {
      success: true,
      data: response.data
    }
  } catch (error) {
    console.error('创建订单失败:', error)
    return {
      success: false,
      message: error.response?.data?.message || error.message || '创建订单失败',
      errors: error.response?.data
    }
  }
}

// 更新订单
export const updateExternalOrder = async (id, data) => {
  try {
    // 如果是 FormData，直接发送；否则清理数据
    let cleanData = data
    if (!(data instanceof FormData)) {
      // 创建一个新对象，排除图片字段和空对象
      cleanData = {}
      const imageFields = ['order_screenshot', 'paypal_refund_screenshot', 'review_screenshot']
      
      Object.keys(data).forEach(key => {
        // 处理图片字段：如果是空字符串，保留它（表示清空）；否则排除
        if (imageFields.includes(key)) {
          if (data[key] === '') {
            cleanData[key] = ''  // 保留空字符串，用于清空字段
          }
          // 其他情况（文件对象、URL等）排除
          return
        }
        
        // 检查是否是空对象
        if (typeof data[key] === 'object' && data[key] !== null && !Array.isArray(data[key])) {
          const keys = Object.keys(data[key])
          if (keys.length === 0) {
            return
          }
        }
        
        // 排除 undefined
        if (data[key] === undefined) {
          return
        }
        
        // 添加有效值
        cleanData[key] = data[key]
      })
    }
  
  // 如果是 FormData，需要设置正确的 headers
    const config = {}
    if (data instanceof FormData) {
      config.headers = {
        'Content-Type': 'multipart/form-data'
      }
    }
    
    const response = await api.put(`/api/orders/external-orders/${id}/`, cleanData, config)
    return {
      success: true,
      data: response.data
    }
  } catch (error) {
    console.error('更新订单失败:', error)
    return {
      success: false,
      message: error.response?.data?.message || error.message || '更新订单失败',
      errors: error.response?.data
    }
  }
}

// 删除订单
export const deleteExternalOrder = async (id) => {
  try {
    await api.delete(`/api/orders/external-orders/${id}/`)
    return {
      success: true,
      message: '订单已删除'
    }
  } catch (error) {
    console.error('删除订单失败:', error)
    return {
      success: false,
      message: error.response?.data?.message || error.message || '删除订单失败'
    }
  }
}

// 批量删除订单
export const bulkDeleteExternalOrders = async (orderIds) => {
  try {
    const response = await api.post('/api/orders/external-orders/bulk_delete/', {
      order_ids: orderIds
    })
    return {
      success: true,
      message: response.data.message || '批量删除成功'
    }
  } catch (error) {
    console.error('批量删除订单失败:', error)
    return {
      success: false,
      message: error.response?.data?.message || error.message || '批量删除订单失败'
    }
  }
}

// 获取订单统计数据
export const getExternalOrderStatistics = async () => {
  try {
    const response = await api.get('/api/orders/external-orders/statistics/')
    return {
      success: true,
      data: response.data.data
    }
  } catch (error) {
    console.error('获取订单统计失败:', error)
    return {
      success: false,
      message: error.response?.data?.message || error.message || '获取订单统计失败'
    }
  }
}

// 获取服务商列表
export const getServiceProviders = async () => {
  try {
    const response = await api.get('/api/orders/external-orders/service_providers/')
    return {
      success: true,
      data: response.data.data
    }
  } catch (error) {
    console.error('获取服务商列表失败:', error)
    return {
      success: false,
      message: error.response?.data?.message || error.message || '获取服务商列表失败',
      data: []
    }
  }
}

// 导出订单
export const exportExternalOrders = async (orderIds = [], format = 'xlsx', filters = {}) => {
  try {
    const payload = {
      order_ids: orderIds,
      format: format
    }
    
    // 如果有筛选条件，添加到payload中
    if (filters.search) payload.search = filters.search
    if (filters.service_provider) payload.service_provider = filters.service_provider
    if (filters.refund_type) payload.refund_type = filters.refund_type
    
    const response = await api.post('/api/orders/external-orders/export/', payload, {
      responseType: 'blob'
    })
    
    // 从响应头获取文件名
    const contentDisposition = response.headers['content-disposition']
    let filename = `orders_${new Date().getTime()}.${format}`
    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename="?(.+)"?/)
      if (filenameMatch) {
        filename = filenameMatch[1]
      }
    }
    
    return {
      success: true,
      data: response.data,
      filename: filename
    }
  } catch (error) {
    console.error('导出订单失败:', error)
    return {
      success: false,
      message: error.response?.data?.message || error.message || '导出订单失败'
    }
  }
}

// 下载导入模板
export const downloadImportTemplate = async (format = 'excel') => {
  try {
    // 根据格式选择不同的API端点
    let endpoint
    if (format === 'csv') {
      endpoint = '/api/orders/external-orders/get_csv_template/'
    } else {
      endpoint = '/api/orders/external-orders/get_excel_template/'
    }
    
    const response = await api.get(endpoint, {
      responseType: 'blob'
    })
    
    // 从响应头获取文件名
    const contentDisposition = response.headers['content-disposition']
    let filename = `order_import_template.${format === 'csv' ? 'csv' : 'xlsx'}`
    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename="?(.+)"?/)
      if (filenameMatch) {
        filename = filenameMatch[1]
      }
    }
    
    return {
      success: true,
      blob: response.data,
      filename: filename
    }
  } catch (error) {
    console.error('下载模板失败:', error)
    return {
      success: false,
      message: error.response?.data?.message || error.message || '下载模板失败'
    }
  }
}

// 批量上传图片
export const batchUploadImages = async (files, onProgress) => {
  try {
    const formData = new FormData()
    files.forEach(file => {
      formData.append('images', file)
    })
    
    const response = await api.post('/api/orders/external-orders/batch_upload_images/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      onUploadProgress: (progressEvent) => {
        if (onProgress && progressEvent.total) {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
          onProgress(percentCompleted)
        }
      }
    })
    return response.data
  } catch (error) {
    console.error('批量上传图片失败:', error)
    return {
      success: false,
      message: error.response?.data?.message || error.message || '批量上传图片失败'
    }
  }
}

// 单张图片上传
export const uploadSingleImage = async (file) => {
  try {
    const formData = new FormData()
    formData.append('image', file)
    
    const response = await api.post('/api/orders/external-orders/upload_single_image/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    return response.data
  } catch (error) {
    console.error('上传图片失败:', error)
    return {
      success: false,
      message: error.response?.data?.message || error.message || '上传图片失败'
    }
  }
}

// 导入订单
export const importExternalOrders = async (formData) => {
  try {
    const response = await api.post('/api/orders/external-orders/import_orders/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    return response.data
  } catch (error) {
    console.error('导入订单失败:', error)
    return {
      success: false,
      message: error.response?.data?.message || error.message || '导入订单失败'
    }
  }
}

// ========== 字段配置相关 ==========

// 获取字段配置列表
export const getFieldConfigs = async () => {
  try {
    // 获取所有字段配置（后端已禁用分页，直接返回数组）
    const response = await api.get('/api/orders/field-configs/')
    // 后端禁用分页后，直接返回数组；如果有分页，则提取 results
    const data = Array.isArray(response.data) ? response.data : (response.data.results || response.data)
    return {
      success: true,
      data: data
    }
  } catch (error) {
    console.error('获取字段配置失败:', error)
    return {
      success: false,
      message: error.response?.data?.message || error.message || '获取字段配置失败',
      data: []
    }
  }
}

// 初始化默认字段配置
export const initializeFieldConfigs = async () => {
  try {
    const response = await api.post('/api/orders/field-configs/initialize/')
    return {
      success: true,
      data: response.data
    }
  } catch (error) {
    console.error('初始化字段配置失败:', error)
    return {
      success: false,
      message: error.response?.data?.message || error.message || '初始化字段配置失败'
    }
  }
}

// 批量更新字段配置
export const batchUpdateFieldConfigs = async (configs) => {
  try {
    const response = await api.post('/api/orders/field-configs/batch_update/', {
      configs: configs
    })
    return {
      success: true,
      data: response.data
    }
  } catch (error) {
    console.error('批量更新字段配置失败:', error)
    return {
      success: false,
      message: error.response?.data?.message || error.message || '批量更新字段配置失败'
    }
  }
}

// 重置字段配置为默认值
export const resetFieldConfigs = async () => {
  try {
    const response = await api.post('/api/orders/field-configs/reset/')
    return {
      success: true,
      data: response.data
    }
  } catch (error) {
    console.error('重置字段配置失败:', error)
    return {
      success: false,
      message: error.response?.data?.message || error.message || '重置字段配置失败'
    }
  }
}

export default {
  getExternalOrders,
  getExternalOrder,
  createExternalOrder,
  updateExternalOrder,
  deleteExternalOrder,
  bulkDeleteExternalOrders,
  getExternalOrderStatistics,
  getServiceProviders,
  exportExternalOrders,
  downloadImportTemplate,
  batchUploadImages,
  uploadSingleImage,
  importExternalOrders,
  getFieldConfigs,
  initializeFieldConfigs,
  batchUpdateFieldConfigs,
  resetFieldConfigs
}

